import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * The Arcanum 2.0 surface: restrained translucent stone with a thin gold
 * hairline. 02_GLOBAL_VISUAL_SYSTEM asks for exactly this and warns against
 * the alternatives -- no glowing borders, no animated gold, no bevels.
 *
 * Translucent so the scene behind it still reads, but dark enough that text
 * keeps its contrast whatever the artwork happens to be doing underneath.
 */
const Panel = React.forwardRef(({ className, as: Tag = 'div', ...props }, ref) => (
  <Tag
    ref={ref}
    className={cn(
      'rounded-xl border border-border bg-card/85 backdrop-blur-sm',
      'shadow-[0_1px_0_0_hsl(var(--gold)/0.08)_inset]',
      className,
    )}
    {...props}
  />
));
Panel.displayName = 'Panel';

/** A ceremonial heading: Cormorant, pale gold, tracked -- short labels only. */
const PanelHeading = ({ className, as: Tag = 'h2', ...props }) => (
  <Tag
    className={cn('font-heading text-lg tracking-[0.12em] uppercase', className)}
    style={{ color: 'hsl(var(--gold-pale))' }}
    {...props}
  />
);

export { Panel, PanelHeading };
